window.pageBootstrap = function () {

    var pageName = document
        .querySelector('script[data-id="bootscript"][data-name]')
        .getAttribute('data-name');


    ///////////////////////////////////
    ////     SHOP BOOTSTRAP START ////
    //////////////////////////////////
    this.pageBootstrap.app = function (user, uxdata) {
        uxdata.user = user;
        // console.log("PageName: " + pageName + ", bootstrapping")
        // console.log("Logged User Detected:")
        // console.log(user)
        // console.log("UX Data Detected:")
        // console.log(uxdata)
        // console.log(user);
        // console.log(uxdata);
        // console.log(pageName);

        window.app = new Vue({
            // store: store,
            el: '#vue-scope',
            mixins: [],
            props: {
                pageLoading: {
                    type: Boolean,
                    default: true
                },
                expandedMenuItems: {
                    type: Array,
                    default: ['']
                },
                expandedDropdownItems: {
                    type: Array,
                    default: []
                },
                currentStep: {
                    type: Number,
                    default: 1
                },
                first_name: {
                    type: String,
                    default: ''
                },
                last_name: {
                    type: String,
                    default: ''
                },
                email_address: {
                    type: String,
                    default: ''
                },
                submittedResponse: {
                    type: Boolean,
                    default: false
                },
                priceRange: {
                    type: Array,
                    default: [1, 4]
                },
                people: {
                    type: Number,
                    default: 1
                },
                weeks: {
                    type: Number,
                    default: 1
                },
            },
            components: {
                'vueSlider': window['vue-slider-component']
            },
            data: function () {
                return uxdata
            },
            computed: {},
            methods: {
                weeksSliderMarks: function(v) { 
                    const obj = v === 1 ? ' week' : ' weeks';
                    return {
                        label: v === this.weeks ? 'for ' + v + obj : v,
                        labelStyle: {
                            fontSize: v === this.weeks ? '30px' : '15px',
                            fontWeight: 'bold',
                            opacity: v === this.weeks ? '1!important' : '0.5',
                            color: v === this.weeks  ? '#ffeb00' : '',
                        }
                    }
                },
                peopleSliderMarks: function(v) { 
                    const obj = v === 1 ? ' person' : ' people';
                    return {
                        label: v === this.people ? 'I need ' + v + obj : v,
                        labelStyle: {
                            fontSize: v === this.people ? '30px' : '15px',
                            fontWeight: 'bold',
                            opacity: v === this.people ? '1!important' : '0.5',
                            color: v === this.people  ? '#ffeb00' : '',
                        }
                    }
                },
                toggleMenuItem: function (toggleRef, forceUnique) {
                    var index = this.expandedMenuItems.indexOf(toggleRef);
                    if (index === -1) {
                        if (forceUnique) {
                            this.expandedMenuItems = []
                        };
                        this.expandedMenuItems.push(toggleRef);
                    } else {
                        this.expandedMenuItems.splice(index, 1);
                    }
                },
                removeMenuItem: function (removeRef) {
                    var index = this.expandedMenuItems.indexOf(removeRef);
                    if (index !== -1) {
                        this.expandedMenuItems.splice(index, 1);
                    }
                },
                addMenuItem: function (addRef) {
                    var index = this.expandedMenuItems.indexOf(addRef);
                    if (index === -1) {
                        this.expandedMenuItems.push(addRef);
                    }
                },
                toggleDropdownItem: function (toggleRef) {
                    var index = this.expandedDropdownItems.indexOf(toggleRef);
                    if (index === -1) {
                        this.expandedDropdownItems.push(toggleRef);
                        if (this.expandedDropdownItems.length > 1) {
                            this.expandedDropdownItems.splice(0, 1);
                        }
                    } else {
                        this.expandedDropdownItems.splice(index, 1);
                    }
                },
                closeDropdowns: function () {
                    if (this.expandedDropdownItems.length > 0) {
                        this.expandedDropdownItems.splice(0, 1);
                    };
                },
                submitForm: function () {
                    var w = this;
                    console.log()
                    var payload = {
                        fields: {
                            "Email" : w.email_address,
                            "First Name" : w.first_name,
                            "Last Name" : w.last_name
                        }
                    };
                    window.frontrest.post(
                        "/.netlify/functions/start",
                        payload
                    )
                    .then(function (user) {
                        console.log('posted');
                        w.submittedResponse = true;
                    })
                    .catch(function (error) {
                        console.log('error');
                        w.submittedResponse = true;
                    });
                },
            },
            mounted: function () {
                window.smoothScroll ? window.smoothScroll(window) : '';
                var widget = this;
                if (pageName === 'index') {
                    // Do something at app mounting for specific pages
                } else {
                    // Waiting for calls to resolve, to set pageloading false.
                    // widget.pageLoading = false;
                }
            },
            // created: function() {
            // }
            // updated: function() {
            // }
        });

    }


    ///////////////////////////////////
    ////     SHOP BOOTSTRAP END  //////
    //////////////////////////////////

    // window.rest.get("users/me")
    //     .then(function (response) {
    //         console.log("logged")
    //         loadUxData(response)
    //     })
    //     .catch(function (error) {
    //         console.log("not logged")
    //         loadUxData(false)
    //     });

    loadUxData(false)


    function loadUxData(user) {
        var user = user;

        Promise.all([
                window.frontrest.get("/assets/scripts/stub_ux_backend.json"),
            ])
            .then(function (dataArray) {
                if (["submit"].indexOf(pageName) !== -1) {
                    window["pageBootstrap"]["app"] && window["pageBootstrap"]["app"](user, dataArray[0]);
                    return Promise.all([
                        window.rest.get("items/")
                    ]);
                } else {
                    console.log("No specific content declared for page, bootstrapping basic.");
                    window["pageBootstrap"]["app"] && window["pageBootstrap"]["app"](user, dataArray[0]);
                    return false;
                }
            })
            .then(function (dataArray) {
                if (dataArray[0]) {
                    window.app._data.items = dataArray[0];
                }
                if (user) {
                    console.log(user)
                    return Promise.all([
                        window.rest.get("somedata/"),
                        window.rest.get("moredata/"),
                    ]);
                } else {
                    return false;
                }
            })
            .then(function (dataArray) {
                if (dataArray) {
                    if (window.app) {
                        window.app._data.somedata = dataArray[0];
                        window.app._data.moredata = dataArray[1];
                        console.log("Data loaded");
                    } else {
                        console.log("No app element detected!")
                    }
                } else {
                    console.log("No data to load except user, ux.");
                }
            })
            .catch(function (error) {
                console.log(error)
                console.log("ERROR LOADING SERVER DATA")
            })
            .finally(function () {
                window.app ? window.app.pageLoading = false : '';
            })
    }


}



//////////////////
// WEBPACK FOOTER
// ./assets/scripts/page_bootstrap.js
// module id = 1
// module chunks = 0